import template from './admin-hotel-edit-images.html';

const DIRECTIVE_NAME = AdminHotelEditImages.DIRECTIVE_NAME = 'ktAdminHotelEditImages';
export default function AdminHotelEditImages() {
    return {
        restrict: 'A',
        controller: AdminHotelEditImagesController,
        controllerAs: 'adminHotelEditImagesCtrl',
        template,
        bindToController: true,
        scope: {
            hotel: `=${DIRECTIVE_NAME}`,
        },
        link: function($scope, $elem, $attrs, adminHotelEditImagesCtrl) {
            adminHotelEditImagesCtrl.$onInit();
        },
    };
}

export function AdminHotelEditImagesController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
        toggle,
    });

    function $onInit() {
    }

    function toggle(image) {
        image.isSelected = !image.isSelected;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-images/admin-hotel-edit-images-component.js